'use strict';

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;window.Modernizr = function (a, b, c) {
  function z(a) {
    j.cssText = a;
  }function A(a, b) {
    return z(m.join(a + ';') + (b || ''));
  }function B(a, b) {
    return (typeof a === 'undefined' ? 'undefined' : (0, _typeof3.default)(a)) === b;
  }function C(a, b) {
    return !!~('' + a).indexOf(b);
  }function D(a, b) {
    for (var _d in a) {
      var _e = a[_d];if (!C(_e, '-') && j[_e] !== c) return b == 'pfx' ? _e : !0;
    }return !1;
  }function E(a, b, d) {
    for (var _e2 in a) {
      var _f = b[a[_e2]];if (_f !== c) return d === !1 ? a[_e2] : B(_f, 'function') ? _f.bind(d || b) : _f;
    }return !1;
  }function F(a, b, c) {
    var d = a.charAt(0).toUpperCase() + a.slice(1),
        e = (a + ' ' + o.join(d + ' ') + d).split(' ');return B(b, 'string') || B(b, 'undefined') ? D(e, b) : (e = (a + ' ' + p.join(d + ' ') + d).split(' '), E(e, b, c));
  }var d = '2.8.3',
      e = {},
      f = !0,
      g = b.documentElement,
      h = 'modernizr',
      i = b.createElement(h),
      j = i.style,
      k,
      l = {}.toString,
      m = ' -webkit- -moz- -o- -ms- '.split(' '),
      n = 'Webkit Moz O ms',
      o = n.split(' '),
      p = n.toLowerCase().split(' '),
      q = {},
      r = {},
      s = {},
      t = [],
      u = t.slice,
      v,
      w = function w(a, c, d, e) {
    var f = void 0,
        i = void 0,
        j = void 0,
        k = void 0,
        l = b.createElement('div'),
        m = b.body,
        n = m || b.createElement('body');if (parseInt(d, 10)) while (d--) {
      j = b.createElement('div'), j.id = e ? e[d] : h + (d + 1), l.appendChild(j);
    }return f = ['&#173;', '<style id="s', h, '">', a, '</style>'].join(''), l.id = h, (m ? l : n).innerHTML += f, n.appendChild(l), m || (n.style.background = '', n.style.overflow = 'hidden', k = g.style.overflow, g.style.overflow = 'hidden', g.appendChild(n)), i = c(l, a), m ? l.parentNode.removeChild(l) : (n.parentNode.removeChild(n), g.style.overflow = k), !!i;
  },
      x = {}.hasOwnProperty,
      y;!B(x, 'undefined') && !B(x.call, 'undefined') ? y = function y(a, b) {
    return x.call(a, b);
  } : y = function y(a, b) {
    return b in a && B(a.constructor.prototype[b], 'undefined');
  }, Function.prototype.bind || (Function.prototype.bind = function (b) {
    var c = this;if (typeof c !== 'function') throw new TypeError();var d = u.call(arguments, 1),
        e = function e() {
      if (this instanceof e) {
        var _a = function _a() {};_a.prototype = c.prototype;var _f2 = new _a(),
            _g = c.apply(_f2, d.concat(u.call(arguments)));return Object(_g) === _g ? _g : _f2;
      }return c.apply(b, d.concat(u.call(arguments)));
    };return e;
  }), q.touch = function () {
    var c = void 0;return 'ontouchstart' in a || a.DocumentTouch && b instanceof DocumentTouch ? c = !0 : w(['@media (', m.join('touch-enabled),('), h, ')', '{#modernizr{top:9px;position:absolute}}'].join(''), function (a) {
      c = a.offsetTop === 9;
    }), c;
  }, q.csstransforms = function () {
    return !!F('transform');
  }, q.csstransforms3d = function () {
    var a = !!F('perspective');return a && 'webkitPerspective' in g.style && w('@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}', function (b, c) {
      a = b.offsetLeft === 9 && b.offsetHeight === 3;
    }), a;
  }, q.fontface = function () {
    var a = void 0;return w('@font-face {font-family:"font";src:url("https://")}', function (c, d) {
      var e = b.getElementById('smodernizr'),
          f = e.sheet || e.styleSheet,
          g = f ? f.cssRules && f.cssRules[0] ? f.cssRules[0].cssText : f.cssText || '' : '';a = /src/i.test(g) && g.indexOf(d.split(' ')[0]) === 0;
    }), a;
  };for (var G in q) {
    y(q, G) && (v = G.toLowerCase(), e[v] = q[G](), t.push((e[v] ? '' : 'no-') + v));
  }return e.addTest = function (a, b) {
    if ((typeof a === 'undefined' ? 'undefined' : (0, _typeof3.default)(a)) === 'object') for (var _d2 in a) {
      y(a, _d2) && e.addTest(_d2, a[_d2]);
    } else {
      a = a.toLowerCase();if (e[a] !== c) return e;b = typeof b === 'function' ? b() : b, typeof f !== 'undefined' && f && (g.className += ' supports-' + (b ? '' : 'no-') + a), e[a] = b;
    }return e;
  }, z(''), i = k = null, e._version = d, e._prefixes = m, e._domPrefixes = p, e._cssomPrefixes = o, e.testProp = function (a) {
    return D([a]);
  }, e.testAllProps = F, e.testStyles = w, g.className = g.className.replace(/(^|\s)util-NoJs(\s|$)/, '$1$2') + (f ? ' supports-js supports-' + t.join(' supports-') : ''), e;
}(window, document);